import * as assert from 'assert';
import { AbstractStore } from './AbstractStore';

export abstract class AStoreWithMappedData<T extends { id: number }> extends AbstractStore {
    protected recordsMap: Map<number, T> = new Map();

    public initializeStore() {
        this.recordsMap.clear();
        return super.initializeStore();
    }

    public allRecords(): T[] {
        return Array.from(this.recordsMap.values());
    }

    protected addRecordsToMap(records: T[]): void {
        records.forEach(record => {
            this.recordsMap.set(record.id, record);
        });
    }

    public getRecords(ids: number[]): T[] {
        let out: T[] = [];

        ids.forEach(id => {
            assert(typeof id === 'number', 'getRecords passed invalid ID: ');
            const record: T | undefined = this.recordsMap.get(id);
            if (record) {
                out.push(record);
            } else {
                // TODO: handle error case gracefully in production
                assert(false, 'getRecords passed unavailable id');
            }
        });

        return out;
    }

    public getSingleRecord(id: number): T {
        const record: T | undefined = this.recordsMap.get(id);

        if (record) {
            return record;
        } else {
            throw new Error('requested unavailable record');
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data_layer/stores/AStoreWithMappedData.ts